export interface NavItem {
  key: string;
  en: string;
  zh: string;
  href: string;
}

export const primaryNav: NavItem[] = [
  { key: 'world', en: 'WORLD', zh: '世界观', href: '#world' },
  { key: 'stories', en: 'STORIES', zh: '品牌故事', href: '#stories' },
  { key: 'characters', en: 'CHARACTERS', zh: 'IP 角色', href: '#characters' },
  { key: 'flavors', en: 'FLAVORS', zh: '一味', href: '#formula' },
  { key: 'journey', en: 'JOURNEY', zh: '味道地图', href: '#map' },
];